<app-business-hero></app-business-hero>
<app-business-industries></app-business-industries>
<app-business-benefits></app-business-benefits>
<app-business-stories></app-business-stories>
